import { render, staticRenderFns } from "./VideoPanel.vue?vue&type=template&id=7a3f4cb1&scoped=true&"
import script from "./VideoPanel.vue?vue&type=script&lang=js&"
export * from "./VideoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3f4cb1",
  null
  
)

export default component.exports